<template>
  <PrimeChip
    :label="props.label"
    :pt="props.pt"
    :unstyled="true"
    :removable="props.removable"
    class="meridia-chip"
    :class="[computedTypeClass]"
  >
    <slot v-if="$slots.default" />
    <template v-slot:icon>
      <span class="flex items-center select-none">
        <slot v-if="$slots.customIcon" name="customIcon" />
        <MeridiaIcon
          v-else-if="props.icon"
          :name="props.icon"
          type="material-icons-outlined"
          class="chip-icon"
        />
      </span>
    </template>
    <template v-slot:removeicon>
      <MeridiaIcon
        name="close"
        type="material-icons-outlined"
        class="chip-icon cursor-pointer select-none"
        @click="emits('removeClicked', $event)"
      />
    </template>
  </PrimeChip>
</template>

<script setup lang="ts">
import { ChipPassThroughOptions } from 'primevue';
import { PassThrough } from '@primevue/core';
import { computed } from 'vue';
import PrimeChip from 'primevue/chip';
import MeridiaIcon from '../icon/MeridiaIcon.vue';

const props = withDefaults(
  defineProps<{
    label: string;
    icon?: string;
    removable?: boolean;
    pt?: PassThrough<ChipPassThroughOptions>;
  }>(),
  {
    removable: true,
  }
);

defineSlots<{
  default: () => any;
  customIcon: () => any;
}>();

const emits = defineEmits<{
  (e: 'removeClicked', event: Event): void;
}>();

const computedTypeClass = computed(() => {
  return {
    default: true,
  };
});
</script>

<style lang="scss" scoped>
.meridia-chip {
  @apply inline-flex items-center gap-2xs py-2xs px-xs radius-full transition-all duration-200;

  &.default {
    @apply bg-neutral-surface-muted text-neutral-text-body text-body-small;

    &:hover {
      @apply bg-neutral-surface-disabled;
    }

    &:active {
      background: linear-gradient(
        0deg,
        rgba(30, 41, 59, 0.1) 0%,
        rgba(30, 41, 59, 0.1) 100%
      );
    }
  }

  .chip-icon {
    @apply icon-xs;
  }
}
</style>
